import { Label } from '@/components/shadcn/ui/label';
import {
  TagInput,
  type TagInputProps,
  type TagValidationResult,
} from '@/shared/ui/tag-input';

import { useFieldContext } from './form';
import { getFieldError } from './get-field-error';

interface FormTagInputProps extends Omit<TagInputProps, 'value' | 'onChange'> {
  label?: string;
  showErrorMessage?: boolean;
}

export function FormTagInput({
  label,
  showErrorMessage = true,
  ...props
}: FormTagInputProps) {
  const field = useFieldContext<string[]>();

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <Label htmlFor={field.name} className="text-sm font-medium">
          {label}
        </Label>
      )}
      <TagInput
        value={field.state.value ?? []}
        onChange={(tags) => field.handleChange(tags)}
        {...props}
      />
      {showErrorMessage && field.state.meta.errors.length > 0 && (
        <span className="text-destructive text-sm">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      )}
    </div>
  );
}

export type { TagValidationResult };
